import { FC } from "react";

interface PinSVGProps {
    width?: number;
    height?: number;
}

const PinSVG: FC<PinSVGProps> = ({ width = "18px", height = "18px" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1918 2.48336C10.6081 1.89974 9.6196 2.09011 9.29447 2.84875L8.23274 5.32611C7.23336 5.13012 6.15664 5.41883 5.38137 6.1941L4.2413 7.33416C4.04604 7.52943 4.04604 7.84601 4.2413 8.04127L5.90484 9.70481L2.31442 13.2952C2.11915 13.4905 2.11915 13.8071 2.31442 14.0023C2.50968 14.1976 2.82626 14.1976 3.02152 14.0023L6.61195 10.4119L8.27554 12.0755C8.36931 12.1693 8.49649 12.222 8.6291 12.222C8.7617 12.222 8.88888 12.1693 8.98265 12.0755L10.1227 10.9354C10.898 10.1602 11.1867 9.08345 10.9907 8.08406L13.4681 7.02234C14.2267 6.69721 14.4171 5.70867 13.8334 5.12504L11.1918 2.48336ZM10.2136 3.24267C10.2601 3.13429 10.4013 3.1071 10.4847 3.19047L13.1263 5.83215C13.2097 5.91553 13.1825 6.05675 13.0741 6.10319L10.1972 7.33615C9.95434 7.44025 9.83439 7.7154 9.92345 7.96421C10.1975 8.72975 10.0272 9.61673 9.4156 10.2283L8.62909 11.0148L5.30196 7.68772L6.08847 6.90121C6.70008 6.2896 7.58706 6.11936 8.35259 6.39336C8.6014 6.48241 8.87655 6.36247 8.98066 6.11956L10.2136 3.24267Z" fill="#9999A7" />
        </svg>
    );
};

export default PinSVG;
